var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-external-01 1",
    clipPath: "url(#clip0_16395_12433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 4.16715V0.500488M11.5 0.500488H7.83333M11.5 0.500488L6.61111 5.38938M4.77778 1.72271H3.43333C2.40667 1.72271 1.89333 1.72271 1.501 1.92254C1.15605 2.09831 0.875598 2.37876 0.699833 2.72371C0.5 3.11604 0.5 3.62938 0.5 4.65604V8.56716C0.5 9.59382 0.5 10.1072 0.699833 10.4995C0.875598 10.8444 1.15605 11.1249 1.501 11.3007C1.89333 11.5005 2.40667 11.5005 3.43333 11.5005H7.34444C8.37111 11.5005 8.88444 11.5005 9.27678 11.3007C9.62173 11.1249 9.90218 10.8444 10.0779 10.4995C10.2778 10.1072 10.2778 9.59382 10.2778 8.56716V7.22271",
    stroke: "#056EE6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16395_12433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/link-external.3c488a3a6ea6dc09e6211a54c2b3910c.svg";
export { ForwardRef as ReactComponent };